import WrapperService from '@/modules/core/services/wrapper-service';

const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/settings';

const serviceName = "Settings-Service: ";

export default class SettingsService {

  static async readFromAPI(setting, successF, errorF) {
    await WrapperService.get(API_URL + '/' + setting, null, serviceName, successF, errorF);
  }
}